import type { Locale } from '@/intl/types'
import { type ParticipantPaymentStatus, ParticipantPaymentStatusValues } from '../../domain/types'
import { ParticipantPaymentInfoAPIResponse } from '../types'

export function getParticipantName(firstName: string, lastName: string): string {
  return `${firstName} ${lastName}`
}

export function getPeriod(startDate: string, endDate: string, locale: Locale = 'nl-NL'): string {
  const startDateObj = new Date(startDate)
  const endDateObj = new Date(endDate)

  if (Number.isNaN(startDateObj.getTime()) || Number.isNaN(endDateObj.getTime())) {
    return ''
  }

  const startDay = startDateObj.toLocaleDateString(locale, { day: 'numeric' })
  const endDay = endDateObj.toLocaleDateString(locale, { day: 'numeric' })
  const month = endDateObj.toLocaleDateString(locale, { month: 'long' })
  const year = endDateObj.toLocaleDateString(locale, { year: 'numeric' })

  return `${startDay} - ${endDay} ${month} ${year}`
}

export function getAmountDue(paymentInfo: ParticipantPaymentInfoAPIResponse): number {
  return paymentInfo.totalToBePaid - paymentInfo.totalPaid
}

export function getParticipantPaymentStatus(paymentInfo: ParticipantPaymentInfoAPIResponse): ParticipantPaymentStatus {
  if (paymentInfo.totalPaid === 0) {
    return ParticipantPaymentStatusValues.NOT_PAID
  }
  if (paymentInfo.totalPaid === paymentInfo.totalToBePaid) {
    return ParticipantPaymentStatusValues.PAID
  }
  if (paymentInfo.totalPaid > paymentInfo.totalToBePaid) {
    return ParticipantPaymentStatusValues.REFUND
  }
  return ParticipantPaymentStatusValues.PARTIAL_PAID
}
